<template>
  <section class="custom-wrapper">
    <div
      class="table-responsive"
      :class="{ 'disabled': $loading.isLoading('getOwnerVehicles') }"
    >
      <!-- Listing -->
      <div
        ref="listingWrapper"
        class="listingWrapper"
      >
        <div class="custom-add-button">
          <button
            class="btn btn-primary btn-sm"
            @click="addVehicle"
          >Add</button>
        </div>
        <dt-table
          v-model="vehicles"
          class="table table-bordered table-striped"
          :isSingleRowDetail="false"
          sortOn="id"
          sortDir="asc"
          :columns="tableColumnsName"
        >
          <template
            slot="tbody"
            slot-scope="props"
          >
            <td class="custom-column-60">
              <a
                href="#"
                @click="showVehicle(props.row)"
              >view</a>
            </td>
            <th
              scope="row"
              class="custom-column-60"
            >{{ props.row.vehicle }}</th>
            <td>{{ props.row.vin }}</td>
            <td>{{ props.row.year }}</td>
            <td>{{ props.row.makeName }}</td>
            <td>{{ props.row.model }}</td>
            <td class="custom-column-60">
              <a
                href="#"
                @click="confirmDelete(props.row)"
              >delete</a>
            </td>
          </template>
          <template slot="empty"> Nothing found! </template>
        </dt-table>
      </div>
    </div>
    <dialog-vehicle
      v-model="actionVehicle"
      @closing="closeModal"
      @send="savedVehicle"
    />
    <confirm-delete
      v-model="actionDelete"
      :tag="'Vehicle'"
      @closing="closeModal"
      @delete="performDelete"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import DtTable from '@/components/utilities/table/dt-table'
import DialogVehicle from '@/components/contacts/forms/vehicle-dialog'
import ConfirmDelete from '@/components/contacts/forms/confirm-delete'
export default {
  name: 'contact-vehicles',
  components: {
    DtTable,
    DialogVehicle,
    ConfirmDelete
  },
  props: {
    contact: Number
  },
  data() {
    return {
      actionVehicle: null,
      actionDelete: null,
      vehicleId: null
    }
  },
  mounted() {
    if (this.contact !== undefined && this.contact !== null) {
      this.getOwnerVehicles(this.contact)
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('vehicles', ['vehicle', 'vehicles']),
    tableColumnsName() {
      return [
        {
          field: 'vehicle',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'vehicle',
          label: '#',
          sortable: true,
          class: 'custom-column-60'
        },
        {
          field: 'vin',
          label: 'VIN',
          sortable: true
        },
        {
          field: 'year',
          label: 'Year',
          sortable: true,
          class: 'custom-column-100 text-center'
        },
        {
          field: 'makeName',
          label: 'Make',
          sortable: true
        },
        {
          field: 'model',
          label: 'Model',
          sortable: true
        }
      ]
    }
  },
  methods: {
    ...mapActions('vehicles', [
      'initVehicle',
      'getVehicle',
      'getOwnerVehicles',
      'setVehicle',
      'updateVehicle',
      'deleteVehicle'
    ]),
    formatDate(date, type = '') {
      let _date = null
      if (date !== undefined && date !== null) {
        if (type === 'datetime') {
          _date = moment.utc(date).format('MM/DD/YYYY hh:mm a')
        } else {
          _date = moment.utc(date).format('MM/DD/YYYY')
        }
      }
      return _date
    },
    closeModal() {
      this.actionVehicle = null
      this.actionDelete = null
    },
    addVehicle() {
      this.initVehicle()
      this.updateVehicle({
        name: 'firm',
        value: this.profile.firm
      })
      this.updateVehicle({
        name: 'contact',
        value: this.contact
      })
      this.actionVehicle = this.contact
    },
    showVehicle(data) {
      this.setVehicle(data)
      this.actionVehicle = this.contact
    },
    async savedVehicle() {
      console.log('Saved Vehicle', this.vehicle)
      await this.getOwnerVehicles(this.contact)
      this.actionVehicle = null
    },
    confirmDelete(data) {
      console.log('Confirm Delete', data)
      this.vehicleId = data.vehicle
      this.actionDelete = true
    },
    async performDelete() {
      console.log('Delete Vehicle', this.vehicleId)
      this.actionDelete = null
      await this.deleteVehicle({
        vehicle: this.vehicleId
      })
      await this.getOwnerVehicles(this.contact)
      this.vehicleId = null
    }
  }
}
</script>
<style lang="scss" scoped>
.table-responsive.disabled {
  position: relative;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.5);
  }
}
.selectRecord {
  outline: 1px solid blue;
}
.listingWrapper {
  position: relative;
  overflow-y: auto;
  max-height: 380px;
}
.custom-wrapper {
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
}
.custom-add-button {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/listings/contact-vehicles.vue